import React, { Component, PropTypes } from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router'

import routes from 'routes'

export default class Root extends Component {
  render() {
    const { history, store } = this.props

    return (
      <Provider store={store}>
        <Router history={history} routes={routes} />
      </Provider>
    )
  }
}

Root.propTypes = {
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
}



/** WEBPACK FOOTER **
 ** ./src/containers/root/root.js
 **/